import { LoadingCircleModule } from './../../shared/component/common/loading-circle/loading-circle.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { HeaderModule } from '../../shared/component/common/header/header.module';
import { ButtonModule } from '../../shared/component/common/button/button.module';
import { LabelModule } from '../../shared/component/common/label/label.module';
import { InputModule } from '../../shared/component/common/input/input.module';
import { CheckboxModule } from '../../shared/component/common/checkbox/checkbox.module';
import { TermsComponent } from './terms.component';
import { ListButtonsModule } from 'src/app/shared/component/common/list-buttons/list-buttons.module';

@NgModule({
  declarations: [TermsComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    InputModule,
    ReactiveFormsModule,
    CheckboxModule,
    ListButtonsModule,
    LoadingCircleModule,
  ]
})
export class TermsComponentModule { }
